exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results {\n  width: 200px;\n  margin: 0px auto; }\n  .search-results .total {\n    padding: 15px 10px;\n    background-color: #dddddd;\n    margin: 4px 0; }\n    .search-results .total .total__label {\n      font-weight: bold; }\n    .search-results .total .total__cost {\n      font-weight: bold; }\n  .search-results .price--old {\n    text-decoration: line-through;\n    color: red; }\n", ""]);

// exports
